export default __webpack_public_path__ + "static/media/ReportLightActive.2737d2f7.svg";